// extracted by mini-css-extract-plugin
module.exports = {"th":"table_th__1fpAm","thead":"table_thead__2QUFG","tr":"table_tr__3zfLQ","td":"table_td__3xKDM"};